import languages from "../../data/projects/enums/languages";
import BaseFilter from "./BaseFilter";

interface UsedLanguagesFilterProps {
  pickedOptions: string[];
  setPickedOptions: (newState: any) => void;
  show: boolean;
  setShow: (key: string) => void;
  displayColumn?: boolean;
  title?: string;
  filterKey?: string;
  isAdd?: boolean;
}

export default function UsedLanguagesFilter({
  pickedOptions,
  setPickedOptions,
  show,
  setShow,
  displayColumn = false,
  title = "Language",
  filterKey = "usedLanguages",
  maxDisplayOptions,
  isAdd,
}: any) {
  return (
    <BaseFilter
      pickedOptions={pickedOptions}
      setPickedOptions={setPickedOptions}
      show={show}
      setShow={setShow}
      displayColumn={displayColumn}
      title={title}
      filterKey={filterKey}
      originalOptions={languages}
      filterType="usedLanguages"
      showProposeButton={true}
      maxDisplayOptions={maxDisplayOptions}
      isAdd={isAdd}
    />
  );
}
